// react
import React from "react";

// react-i18next
import { useTranslation } from "react-i18next";

// @mui
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";

// A ---------------------------------------------------------------------- M

const Copyright = () => {
  const { t } = useTranslation();

  return (
    <Box component="footer" sx={{ textAlign: "center" }}>
      <Typography variant="body2" align="center" sx={{ color: "rgba(255, 255, 255, 0.8)", opacity: 0.65, fontSize: "0.75rem", letterSpacing: "0.05em" }}>
        {"Copyright © "}
        <Link
          href="https://armilis.com/"
          underline="hover"
          sx={{
            color: "rgba(255, 255, 255, 0.8)",
          }}
        >
          Armilis
        </Link>{" "}
        {new Date().getFullYear()}
      </Typography>
      <Typography variant="body2" align="center" sx={{ color: "rgba(255, 255, 255, 0.8)", opacity: 0.5, fontSize: "0.75rem", letterSpacing: "0.05em" }}>
        {t("all_rights_reserved")}
      </Typography>
      <Typography variant="body2" align="center" sx={{ color: "rgba(255, 255, 255, 0.8)", opacity: 0.5, fontSize: "0.75rem", letterSpacing: "0.05em" }}>
        v{process.env.REACT_APP_RELEASE_VERSION}
      </Typography>
      {process.env.REACT_APP_ENVIRONMENT_URL === "https://nightly.twins.armilis.com" && (
        <Typography variant="body2" align="center" sx={{ color: "rgba(255, 255, 255, 0.8)", opacity: 0.5, fontSize: "0.75rem", letterSpacing: "0.05em" }}>
          <i>Nightly Channel</i>
        </Typography>
      )}
    </Box>
  );
};

export default Copyright;
